var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "checkout xl:px-80 lg:px-32 md:px-40 px-20" },
    [
      _vm.message != null && _vm.message != ""
        ? _c(
            "div",
            {
              staticClass:
                "bg-blue rounded-xs text-14 flex items-center w-full px-16 py-16 mb-20 font-medium leading-snug text-white"
            },
            [_vm._v(_vm._s(_vm.message))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("ValidationObserver", {
        ref: "observer",
        attrs: { tag: "div", slim: true },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              return [
                _c(
                  "form",
                  {
                    key: _vm._uid,
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.submit($event)
                      }
                    }
                  },
                  [
                    _c("el-error", { attrs: { error: _vm.server_error } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "-mx-30 lg:-mx-16 xl:-mx-30 flex flex-wrap"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-30 lg:px-16 xl:px-30 lg:w-1/3 w-full"
                          },
                          [
                            _c("h5", { staticClass: "mb-16" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.translations.checkout_data.personal_info
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "mb-16",
                              attrs: {
                                name: "email",
                                rules: "required|email",
                                label: _vm.translations.checkout_data.email
                              },
                              model: {
                                value: _vm.formData.client.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData.client, "email", $$v)
                                },
                                expression: "formData.client.email"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "mb-16",
                              attrs: {
                                name: "phone",
                                rules: {
                                  required: true,
                                  regex: /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/
                                },
                                label: _vm.translations.checkout_data.phone
                              },
                              model: {
                                value: _vm.formData.client.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData.client, "phone", $$v)
                                },
                                expression: "formData.client.phone"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex mb-40" }, [
                              _c(
                                "div",
                                { staticClass: "flex items-center mr-32" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.formData.client.type,
                                        expression: "formData.client.type"
                                      }
                                    ],
                                    attrs: {
                                      type: "radio",
                                      id: "particulier",
                                      value: "private"
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.formData.client.type,
                                        "private"
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.formData.client,
                                          "type",
                                          "private"
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "ml-8",
                                      attrs: { for: "particulier" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translations.checkout_data.private
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex items-center" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.formData.client.type,
                                      expression: "formData.client.type"
                                    }
                                  ],
                                  attrs: {
                                    type: "radio",
                                    id: "bedrijf",
                                    value: "company"
                                  },
                                  domProps: {
                                    checked: _vm._q(
                                      _vm.formData.client.type,
                                      "company"
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.formData.client,
                                        "type",
                                        "company"
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "ml-8",
                                    attrs: { for: "bedrijf" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translations.checkout_data.company
                                      )
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.formData.client.type === "company"
                              ? [
                                  _c("el-input", {
                                    staticClass: "mb-16",
                                    attrs: {
                                      name: "company",
                                      rules: "required",
                                      label:
                                        _vm.translations.checkout_data
                                          .company_name
                                    },
                                    model: {
                                      value: _vm.formData.client.company_name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData.client,
                                          "company_name",
                                          $$v
                                        )
                                      },
                                      expression: "formData.client.company_name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticClass: "mb-40",
                                    attrs: {
                                      rules: {
                                        required: true,
                                        regex: /^((AT)U[0-9]{8}|(BE)[0-9]{10}|(BG)[0-9]{9,10}|(HR)[0-9]{11}|(CY)[0-9]{8}L|(CZ)[0-9]{8,10}|(DE)[0-9]{9}|(DK)[0-9]{8}|(EE)[0-9]{9}|(EL|GR)[0-9]{9}|ES[A-Z][0-9]{7}(?:[0-9]|[A-Z])|(FI)[0-9]{8}|(FR)[0-9A-Z]{2}[0-9]{9}|(GB)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)[0-9]{8}|(IE)[0-9]S[0-9]{5}L|(IT)[0-9]{11}|(LT)([0-9]{9}|[0-9]{12})|(LU)[0-9]{8}|(LV)[0-9]{11}|(MT)[0-9]{8}|(NL)[0-9]{9}B[0-9]{2}|(PL)[0-9]{10}|(PT)[0-9]{9}|(RO)[0-9]{2,10}|(SE)[0-9]{12}|(SI)[0-9]{8}|(SK)[0-9]{10})$/
                                      },
                                      name: "vatNumber",
                                      label:
                                        _vm.translations.checkout_data
                                          .vat_number,
                                      placeholder: "BE0123456789"
                                    },
                                    on: { input: _vm.vatUpper },
                                    model: {
                                      value: _vm.formData.client.vat_number,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData.client,
                                          "vat_number",
                                          $$v
                                        )
                                      },
                                      expression: "formData.client.vat_number"
                                    }
                                  })
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "mb-16",
                              attrs: {
                                name: "firstName",
                                rules: "required",
                                label: _vm.translations.checkout_data.first_name
                              },
                              model: {
                                value: _vm.formData.client.first_name,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData.client,
                                    "first_name",
                                    $$v
                                  )
                                },
                                expression: "formData.client.first_name"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "mb-40",
                              attrs: {
                                name: "name",
                                rules: "required",
                                label: _vm.translations.checkout_data.name
                              },
                              model: {
                                value: _vm.formData.client.last_name,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData.client,
                                    "last_name",
                                    $$v
                                  )
                                },
                                expression: "formData.client.last_name"
                              }
                            }),
                            _vm._v(" "),
                            _c("h5", { staticClass: "mb-16" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.translations.checkout_data.payment_address
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "mb-16",
                              attrs: {
                                name: "payment_street",
                                rules: "required",
                                label: _vm.translations.checkout_data.street
                              },
                              model: {
                                value: _vm.formData.billing_address.street,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData.billing_address,
                                    "street",
                                    $$v
                                  )
                                },
                                expression: "formData.billing_address.street"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex -mx-8" }, [
                              _c(
                                "div",
                                { staticClass: "w-1/2 px-8" },
                                [
                                  _c("el-input", {
                                    staticClass: "mb-16",
                                    attrs: {
                                      name: "payment_number",
                                      rules: "required",
                                      label:
                                        _vm.translations.checkout_data.number
                                    },
                                    model: {
                                      value:
                                        _vm.formData.billing_address.number,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData.billing_address,
                                          "number",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.billing_address.number"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-1/2 px-8" },
                                [
                                  _c("el-input", {
                                    staticClass: "mb-16",
                                    attrs: {
                                      name: "payment_addition",
                                      label:
                                        _vm.translations.checkout_data.addition
                                    },
                                    model: {
                                      value:
                                        _vm.formData.billing_address.addition,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData.billing_address,
                                          "addition",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.billing_address.addition"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex -mx-8" }, [
                              _c(
                                "div",
                                { staticClass: "w-1/3 px-8" },
                                [
                                  _c("el-input", {
                                    staticClass: "mb-16",
                                    attrs: {
                                      name: "payment_postalCode",
                                      rules: "required",
                                      label:
                                        _vm.translations.checkout_data
                                          .postal_code
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.calculateShippingCosts()
                                      }
                                    },
                                    model: {
                                      value: _vm.formData.billing_address.zip,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData.billing_address,
                                          "zip",
                                          $$v
                                        )
                                      },
                                      expression: "formData.billing_address.zip"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-2/3 px-8" },
                                [
                                  _c("el-input", {
                                    staticClass: "mb-16",
                                    attrs: {
                                      name: "payment_place",
                                      rules: "required",
                                      label:
                                        _vm.translations.checkout_data.location
                                    },
                                    model: {
                                      value: _vm.formData.billing_address.city,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData.billing_address,
                                          "city",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.billing_address.city"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "text-14 inline-block mb-16 font-medium",
                                staticStyle: { color: "#6c6c70" }
                              },
                              [
                                _vm._v(
                                  "* " +
                                    _vm._s(
                                      _vm.translations.checkout_data.country
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-select", {
                              staticClass: "mb-16",
                              attrs: {
                                clearable: false,
                                options: _vm.availableCountries
                              },
                              on: {
                                input: function(val) {
                                  _vm.formData.billing_address.country = _vm.translations.checkout_data.countries.find(
                                    function(c) {
                                      return c.country_name === val
                                    }
                                  ).country_code
                                  _vm.calculateShippingCosts()
                                }
                              },
                              model: {
                                value: _vm.billing_address_country,
                                callback: function($$v) {
                                  _vm.billing_address_country = $$v
                                },
                                expression: "billing_address_country"
                              }
                            }),
                            _vm._v(" "),
                            _vm.shippingAllowed
                              ? _c("el-input", {
                                  staticClass: "mb-40",
                                  attrs: {
                                    name: "shipping_same",
                                    type: "checkbox",
                                    label:
                                      _vm.translations.checkout_data
                                        .same_address
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.calculateShippingCosts()
                                    }
                                  },
                                  model: {
                                    value: _vm.formData.shipping_same,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "shipping_same",
                                        $$v
                                      )
                                    },
                                    expression: "formData.shipping_same"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.formData.shipping_same
                              ? [
                                  _c("h5", { staticClass: "mb-16" }, [
                                    _vm._v("Afleveradres")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticClass: "mb-16",
                                    attrs: {
                                      name: "delivery_street",
                                      rules: "required",
                                      label:
                                        _vm.translations.checkout_data.street
                                    },
                                    model: {
                                      value:
                                        _vm.formData.shipping_address.street,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formData.shipping_address,
                                          "street",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.shipping_address.street"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flex -mx-8" }, [
                                    _c(
                                      "div",
                                      { staticClass: "w-1/2 px-8" },
                                      [
                                        _c("el-input", {
                                          staticClass: "mb-16",
                                          attrs: {
                                            name: "delivery_number",
                                            rules: "required",
                                            label:
                                              _vm.translations.checkout_data
                                                .number
                                          },
                                          model: {
                                            value:
                                              _vm.formData.shipping_address
                                                .number,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData.shipping_address,
                                                "number",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.shipping_address.number"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "w-1/2 px-8" },
                                      [
                                        _c("el-input", {
                                          staticClass: "mb-16",
                                          attrs: {
                                            name: "delivery_addition",
                                            label:
                                              _vm.translations.checkout_data
                                                .addition
                                          },
                                          model: {
                                            value:
                                              _vm.formData.shipping_address
                                                .addition,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData.shipping_address,
                                                "addition",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.shipping_address.addition"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flex -mx-8" }, [
                                    _c(
                                      "div",
                                      { staticClass: "w-1/3 px-8" },
                                      [
                                        _c("el-input", {
                                          staticClass: "mb-16",
                                          attrs: {
                                            name: "delivery_postalCode",
                                            rules: "required",
                                            label:
                                              _vm.translations.checkout_data
                                                .postal_code
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.calculateShippingCosts()
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.formData.shipping_address.zip,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData.shipping_address,
                                                "zip",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.shipping_address.zip"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "w-2/3 px-8" },
                                      [
                                        _c("el-input", {
                                          staticClass: "mb-16",
                                          attrs: {
                                            name: "delivery_place",
                                            rules: "required",
                                            label:
                                              _vm.translations.checkout_data
                                                .location
                                          },
                                          model: {
                                            value:
                                              _vm.formData.shipping_address
                                                .city,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.formData.shipping_address,
                                                "city",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.shipping_address.city"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "text-14 inline-block mb-16 font-medium",
                                      staticStyle: { color: "#6c6c70" }
                                    },
                                    [
                                      _vm._v(
                                        "* " +
                                          _vm._s(
                                            _vm.translations.checkout_data
                                              .location
                                          )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-select", {
                                    staticClass: "mb-40",
                                    attrs: {
                                      clearable: false,
                                      options: _vm.availableCountries
                                    },
                                    on: {
                                      input: function(val) {
                                        _vm.formData.shipping_address.country = _vm.translations.checkout_data.countries.find(
                                          function(c) {
                                            return c.country_name === val
                                          }
                                        ).country_code
                                        _vm.calculateShippingCosts()
                                      }
                                    },
                                    model: {
                                      value: _vm.shipping_address_country,
                                      callback: function($$v) {
                                        _vm.shipping_address_country = $$v
                                      },
                                      expression: "shipping_address_country"
                                    }
                                  })
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "lg:mb-0 mb-40",
                              attrs: {
                                name: "remark",
                                type: "textarea",
                                label: _vm.translations.checkout_data.message
                              },
                              model: {
                                value: _vm.formData.remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "remark", $$v)
                                },
                                expression: "formData.remark"
                              }
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-30 lg:px-16 xl:px-30 lg:w-1/3 w-full"
                          },
                          [
                            _c("h5", { staticClass: "mb-16" }, [
                              _vm._v(
                                _vm._s(_vm.translations.checkout_data.shipment)
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-14 mb-16 font-medium text-gray-500"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.translations.checkout_data
                                      .only_pickup_message
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded-xs p-24 mb-16 bg-gray-100",
                                on: { click: _vm.clickChildInput }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.shipping_method,
                                          expression: "formData.shipping_method"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        id: "zelf-afhalen",
                                        value: "pick_up"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.formData.shipping_method,
                                          "pick_up"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "shipping_method",
                                            "pick_up"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "ml-8",
                                        attrs: { for: "zelf-afhalen" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translations.checkout_data
                                              .pickup
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.shippingAllowed
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "rounded-xs p-24 mb-40 bg-gray-100",
                                    on: { click: _vm.clickChildInput }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex justify-between mb-0"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex items-center" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.formData
                                                      .shipping_method,
                                                  expression:
                                                    "formData.shipping_method"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                disabled: !_vm.shippingAllowed,
                                                id: "verzending",
                                                value: "delivery"
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.formData.shipping_method,
                                                  "delivery"
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.$set(
                                                    _vm.formData,
                                                    "shipping_method",
                                                    "delivery"
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "ml-8",
                                                attrs: { for: "verzending" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.translations
                                                      .checkout_data
                                                      .shipment_label
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("tooltip", {
                                              attrs: {
                                                text:
                                                  _vm.translations.checkout_data
                                                    .shipment_tooltip
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.priceAtRequest
                                          ? _c(
                                              "span",
                                              { staticClass: "text-gray-500" },
                                              [_vm._v("Op aanvraag")]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "text-gray-500" },
                                              [
                                                _vm._v(
                                                  "€ " +
                                                    _vm._s(
                                                      _vm.$store.getters[
                                                        "pricesIncludingVat"
                                                      ]
                                                        ? _vm.shippingCostsVatIncl
                                                        : _vm.shippingCosts
                                                    )
                                                )
                                              ]
                                            )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    false
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex justify-between pl-24"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flex items-center"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.formData
                                                          .forklift_required,
                                                      expression:
                                                        "formData.forklift_required"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "checkbox",
                                                    disabled:
                                                      !_vm.shippingAllowed ||
                                                      _vm.formData
                                                        .shipping_method !==
                                                        "delivery",
                                                    id: "kooiaap"
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.formData
                                                        .forklift_required
                                                    )
                                                      ? _vm._i(
                                                          _vm.formData
                                                            .forklift_required,
                                                          null
                                                        ) > -1
                                                      : _vm.formData
                                                          .forklift_required
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a =
                                                          _vm.formData
                                                            .forklift_required,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.formData,
                                                              "forklift_required",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.formData,
                                                              "forklift_required",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.formData,
                                                          "forklift_required",
                                                          $$c
                                                        )
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "ml-8",
                                                    attrs: { for: "kooiaap" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.translations
                                                          .checkout_data
                                                          .forklift_necessary
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "text-gray-500" },
                                              [_vm._v("€ 60")]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("h5", { staticClass: "mb-24" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.translations.checkout_data.payment_options
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded-xs p-24 mb-16 bg-gray-100",
                                on: { click: _vm.clickChildInput }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.payment_method,
                                          expression: "formData.payment_method"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        id: "bancontact",
                                        value: "bancontact"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.formData.payment_method,
                                          "bancontact"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "payment_method",
                                            "bancontact"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "ml-16",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.svg("bancontact"))
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "ml-16",
                                        attrs: { for: "bancontact" }
                                      },
                                      [_vm._v("Bancontact")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded-xs p-24 mb-16 bg-gray-100",
                                on: { click: _vm.clickChildInput }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.payment_method,
                                          expression: "formData.payment_method"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        id: "ideal",
                                        value: "ideal"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.formData.payment_method,
                                          "ideal"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "payment_method",
                                            "ideal"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "ml-16",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.svg("ideal"))
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "ml-16",
                                        attrs: { for: "ideal" }
                                      },
                                      [_vm._v("iDEAL")]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded-xs p-24 mb-16 bg-gray-100",
                                on: { click: _vm.clickChildInput }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.payment_method,
                                          expression: "formData.payment_method"
                                        }
                                      ],
                                      attrs: {
                                        type: "radio",
                                        id: "visa",
                                        value: "creditcard"
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.formData.payment_method,
                                          "creditcard"
                                        )
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "payment_method",
                                            "creditcard"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-col ml-16" },
                                      [
                                        _c("span", {
                                          staticClass: "svg-w-36 mb-4",
                                          domProps: {
                                            innerHTML: _vm._s(_vm.svg("visa"))
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "svg-w-36",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.svg("mastercard")
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "ml-16",
                                        attrs: { for: "visa" }
                                      },
                                      [
                                        _c("div", [_vm._v("Kredietkaart")]),
                                        _vm._v(" "),
                                        _vm.creditcard_fee
                                          ? _c("div", [
                                              _c(
                                                "small",
                                                {
                                                  staticClass: "text-gray-500"
                                                },
                                                [
                                                  _vm._v(
                                                    "Transactiekost: +2% (€" +
                                                      _vm._s(
                                                        _vm.formatCurrency(
                                                          _vm.creditcard_fee
                                                        )
                                                      ) +
                                                      ") - Directe verzending"
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.$store.getters["isReseller"]
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "rounded-xs p-24 mb-16 bg-gray-100",
                                    on: { click: _vm.clickChildInput }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.formData.payment_method,
                                              expression:
                                                "formData.payment_method"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            id: "banktransfer",
                                            value: "banktransfer"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.formData.payment_method,
                                              "banktransfer"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                _vm.formData,
                                                "payment_method",
                                                "banktransfer"
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "ml-16",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.svg("mastercard")
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "ml-16",
                                            attrs: { for: "banktransfer" }
                                          },
                                          [_vm._v("Bankoverschrijving")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$store.getters["isReseller"] &&
                            _vm.$store.getters["payByInvoice"]
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "rounded-xs p-24 mb-16 bg-gray-100",
                                    on: { click: _vm.clickChildInput }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex items-center" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.formData.payment_method,
                                              expression:
                                                "formData.payment_method"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            id: "invoice",
                                            value: "invoice"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.formData.payment_method,
                                              "invoice"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                _vm.formData,
                                                "payment_method",
                                                "invoice"
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-10" }, [
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "w-32 h-32",
                                              attrs: {
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  "stroke-linecap": "round",
                                                  "stroke-linejoin": "round",
                                                  "stroke-width": "2",
                                                  d:
                                                    "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                }
                                              })
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "ml-10",
                                            attrs: { for: "invoice" }
                                          },
                                          [_vm._v("Factuur")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-30 lg:px-16 xl:px-30 lg:w-1/3 w-full"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded-xs lg:p-32 p-24 mb-24 bg-gray-100"
                              },
                              [
                                _c("h5", { staticClass: "mb-24" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translations.checkout_data
                                        .samenvatting
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.basket.products, function(product) {
                                  return _c(
                                    "div",
                                    {
                                      key: product.id,
                                      staticClass: "flex mb-8"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "inline-block w-40 pr-16 text-black"
                                        },
                                        [_vm._v(_vm._s(product.amount) + "x")]
                                      ),
                                      _vm._v(" "),
                                      _c("p", {
                                        staticClass:
                                          "text-16 whitespace-nowrap overflow-ellipsis mb-8 overflow-hidden text-black",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            product.productData.name
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "flex-shrink-0 pl-16 ml-auto text-gray-500"
                                        },
                                        [
                                          _vm._v(
                                            "€ " +
                                              _vm._s(
                                                _vm.formatCurrency(
                                                  _vm.getVariantPrice(product)
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.formData.shipping_method == "delivery"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex justify-between mt-24 mb-8"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-black" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translations.checkout_data
                                                  .shipment
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.priceAtRequest
                                          ? _c(
                                              "span",
                                              { staticClass: "text-gray-500" },
                                              [_vm._v("Op aanvraag")]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "text-gray-500" },
                                              [
                                                _vm._v(
                                                  "€ " +
                                                    _vm._s(
                                                      _vm.formatCurrency(
                                                        _vm.shippingCost
                                                      )
                                                    )
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.forklift_required &&
                                _vm.formData.shipping_method == "delivery"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "flex justify-between mb-8"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-black" },
                                          [_vm._v("Kooiaap")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "text-gray-500" },
                                          [
                                            _vm._v(
                                              "€ " +
                                                _vm._s(
                                                  _vm.formatCurrency(
                                                    _vm.forkliftCost
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("hr", {
                                  staticClass: "my-24 border-gray-500"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex justify-between mb-8" },
                                  [
                                    _c("span", { staticClass: "text-black" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translations.checkout_data
                                            .subtotal
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-gray-500" },
                                      [
                                        _vm._v(
                                          "€ " +
                                            _vm._s(_vm.subTotalPlusShipping)
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex justify-between mb-8" },
                                  [
                                    _c("span", { staticClass: "text-black" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translations.checkout_data.vat
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-gray-500" },
                                      [
                                        _vm._v(
                                          "€ " + _vm._s(_vm.vatPlusShippingVat)
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.formData.payment_method === "creditcard"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "flex justify-between mb-8"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-black" },
                                          [_vm._v("Transactiekost")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "text-gray-500" },
                                          [
                                            _vm._v(
                                              "€ " +
                                                _vm._s(
                                                  _vm.formatCurrency(
                                                    _vm.creditcard_fee
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex justify-between mb-24" },
                                  [
                                    _c("span", { staticClass: "text-black" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translations.checkout_data
                                            .shipment
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-gray-500" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formData.shipping_method ===
                                              "delivery"
                                              ? "Verzending"
                                              : "Zelf afhalen"
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex justify-between mb-24" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-20 font-bold text-black"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translations.checkout_data.total
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-gray-500" },
                                      [_vm._v("€ " + _vm._s(_vm.absoluteTotal))]
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c("p", {
                                  staticClass: "mb-24",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.translations.checkout_data.terms
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _vm.$store.getters["basketErrors"].length &&
                                _vm.$store.getters["basketErrors"].find(
                                  function(e) {
                                    return [
                                      "out_of_stock",
                                      "not_enough_stock"
                                    ].includes(e.issue)
                                  }
                                )
                                  ? _c(
                                      "tooltip",
                                      {
                                        staticClass: "w-full",
                                        attrs: {
                                          text:
                                            _vm.translations.shopping_basket
                                              .shopping_basket_stock_error
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn btn-rounded w-full mb-24 text-center text-white border-none pointer-events-none",
                                            staticStyle: {
                                              "background-color":
                                                "rgba(35, 179, 47, 0.6)"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translations.checkout_data
                                                  .submit_button
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "bg-red text-12 inline-flex items-center justify-center w-16 h-16 ml-16 font-bold text-white rounded-full"
                                              },
                                              [_vm._v("!")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm.$store.getters["basketErrors"].length &&
                                    _vm.$store.getters["basketErrors"].find(
                                      function(e) {
                                        return (
                                          e.issue === "order_amount_too_low"
                                        )
                                      }
                                    )
                                  ? _c(
                                      "tooltip",
                                      {
                                        staticClass: "w-full",
                                        attrs: {
                                          text: _vm.translations.shopping_basket.order_amount_too_low.replace(
                                            /\{{(.+?)\}}/g,
                                            _vm.$store.getters["customer"]
                                              .min_order_amount
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn btn-rounded w-full mb-24 text-center text-white border-none pointer-events-none",
                                            staticStyle: {
                                              "background-color":
                                                "rgba(35, 179, 47, 0.6)"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.translations.checkout_data
                                                  .submit_button
                                              )
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "bg-red text-12 inline-flex items-center justify-center w-16 h-16 ml-16 font-bold text-white rounded-full"
                                              },
                                              [_vm._v("!")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _c("el-button", {
                                      staticClass:
                                        "btn btn-green btn-rounded w-full mb-24",
                                      attrs: {
                                        "no-arrow": true,
                                        loading: _vm.loading,
                                        success: _vm.success,
                                        loadingLabel:
                                          _vm.translations.checkout_data
                                            .submit_button,
                                        successLabel:
                                          _vm.translations.checkout_data
                                            .submit_button,
                                        defaultLabel:
                                          _vm.translations.checkout_data
                                            .submit_button,
                                        disabled: invalid
                                      },
                                      on: { click: _vm.submit }
                                    }),
                                _vm._v(" "),
                                _c("p", [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "hover:border-transparent leading-tight transition-colors border-b border-black",
                                      attrs: {
                                        href: "/contact",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.translations.checkout_data
                                            .help_label
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }